import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(
  theme => ({
    buttonContainer: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    card: {
      borderRadius: 16,
      boxShadow: theme.shadows[3],
      marginBottom: theme.spacing(2),
      padding: theme.spacing(0),
      textAlign: "center",
      width: 500
    },
    cardLockedOut: {
      borderRadius: 16,
      boxShadow: theme.shadows[3],
      marginBottom: theme.spacing(2),
      padding: theme.spacing(0),
      textAlign: "center",
      width: 500
    },
    centerContainer: {
      alignItems: "center",
      backgroundColor: theme.palette.background.default,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minHeight: "100vh",
      padding: theme.spacing(1)
    },
    circularProgress: {
      color: "#247CFF",
      marginLeft: 8,
      marginTop: 4
    },
    container: {
      alignItems: "center",
      backgroundColor: "#DEF8FA",
      borderRadius: "0 0 16px 16px",
      display: "flex",
      justifyContent: "center",
      marginTop: 35,
      padding: theme.spacing(1.5)
    },
    containerError: {
      alignItems: "center",
      backgroundColor: "#FEE4ED",
      borderRadius: "0 0 16px 16px",
      display: "flex",
      justifyContent: "center",
      marginTop: 35,
      padding: theme.spacing(1.5)
    },
    defaultBackground: {
      backgroundColor: "#f9f9f9"
    },
    errorBackground: {
      backgroundColor: "#FEE4ED"
    },
    getStartedButton: {
      "&:hover": {
        backgroundColor: "#1039C9"
      },
      backgroundColor: "#1848FE",
      color: "#fff",
      marginBottom: theme.spacing(1.5),
      padding: theme.spacing(1.5),
      width: "100%"
    },
    icon: {
      color: "#246C63",
      marginRight: theme.spacing(1)
    },
    iconError: {
      color: "#EC5D77",
      marginRight: theme.spacing(1)
    },
    infoCard: {
      alignItems: "center",
      backgroundColor: "#F4F8FF",
      border: "1px solid #00205B",
      borderRadius: 8,
      color: "#002972",
      display: "flex",
      fontSize: 12,
      marginTop: theme.spacing(2),
      padding: theme.spacing(1.0),
      width: "100%"
    },
    infoCardNoBorderColor: {
      alignItems: "center",
      backgroundColor: "#F4F8FF",
      borderRadius: 8,
      color: "#002972",
      display: "flex",
      fontSize: 12,
      marginBottom: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(2),
      padding: theme.spacing(1.0)
    },
    infoIcon: {
      marginRight: theme.spacing(1),
      stroke: "#002972",
      strokeWidth: 1.5
    },
    infoLogo: {
      height: 20,
      margin: theme.spacing(1)
    },
    infoLogoLockedOut: {
      height: 70,
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(3)
    },
    input: {
      alignItems: "center",
      display: "flex",
      fontSize: 50,
      height: "100%",
      justifyContent: "center",
      padding: 12,
      textAlign: "center"
    },
    logo: {
      height: 70,
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3)
    },
    outlinedInput: {
      borderRadius: "10px",
      boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)"
    },
    pointerDisabled: {
      pointerEvents: "none"
    },
    pointerEnabled: {
      pointerEvents: "auto"
    },

    setupLaterButton: {
      "& .MuiButton-label": {
        fontWeight: 166
      },
      borderColor: "#1848FE",
      color: "#1848FE",
      padding: theme.spacing(1.5),
      width: "100%"
    },
    subtitle: {
      fontSize: 16,
      fontWeight: 400,
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      textAlign: "center"
    },
    subtitle12: {
      color: "#002972",
      fontSize: 12,
      fontWeight: 400,
      padding: theme.spacing(2),
      textAlign: "center"
    },
    subtitleLockedOut: {
      fontFamily: "Henry Sans",
      fontSize: 16,
      fontWeight: 400,
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      textAlign: "center"
    },
    successBackground: {
      backgroundColor: "#DEF8FA"
    },

    text: {
      color: "#246C63",
      fontSize: "14px"
    },
    textAttemptError: {
      color: "#EC5D77",
      fontSize: "14px",
      marginTop: 10
    },
    textError: {
      color: "#EC5D77",
      fontSize: "14px"
    },
    textField: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      width: 70
    },
    textResendCode: {
      color: "#247CFF",
      display: "flex",
      flexDirection: "row",
      fontSize: 17,
      fontWeight: 130,
      justifyContent: "center",
      padding: theme.spacing(2),
      textAlign: "center"
    },
    textValidatingCode: {
      color: "#247CFF",
      fontSize: 18,
      fontWeight: 500,
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      textAlign: "center"
    },
    title: {
      color: "#0030FF",
      fontSize: 26,
      fontWeight: 700,
      padding: theme.spacing(2),
      textAlign: "center"
    },
    titleLockedOut: {
      color: "#EC5D77",
      fontSize: 26,
      fontWeight: 700,
      padding: theme.spacing(1),
      textAlign: "center"
    },
    validationContainer: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      marginTop: 16
    }
  }),
  { name: "MfaInputCodePage" }
);
